<template>
  <!-- 模拟测验 -->
  <div >
    <Spin v-if="tkLoading" size='large'></Spin>
    <div v-else class="paper">
      <Row :gutter="60" style="width:100%" v-if="paperList.length">
        <i-col :md="12" :lg="8" :xl="8" :xxl="6" :style="{ marginBottom: '30px' }" v-for="(item, i) in paperList" :key="i">
          <div class="test-paper">
            <div class="left-top">{{ item.answerCount }}人做过</div>
            <div class="time"><Icon type="ios-time" color="#FF9D00" size="18"/>{{ item.examTime }}分钟</div>
            <div class="title" :title="item.examPaperName">{{ item.examPaperName }}</div>
            <div class="count-info">
              <span class="ct">{{ item.totalCount }}题</span><span class="center">|</span><span class="as">平均分:{{ parseInt(item.answerAvgScore) }}分</span>
            </div>
            <Button class="btnActive" type="primary" shape="circle" size="large" @click="enterTest(item)">进入练习</Button>
          </div>
        </i-col>
      </Row>
      <nullPage v-else style="width:100%">
          <div slot="tipsText">暂无信息，点击右上角去激活吧！</div>
      </nullPage>
    </div>

  </div>
</template>
<script>
import nullPage from './components/nullPage.vue'
export default {
  components:{  nullPage },
  props: {
    paperList: {
      type: Array,
      default: null
    },
    tkLoading:{
        type: Boolean,
        default:false
    }
  },
  data() {
    return {
      modalShow: false,
    }
  },
  methods: {
    enterTest(item) {
      // console.log(item.examPaperId)
      this.$router.push({
        name: 'simulationTestDetail',
        query: item
      })

      // this.modalShow = true
      // this.$refs.child.$emit('childcountdown')
      // this.currInfo = item
    }
  },
  mounted() {},
  watch: {},
  computed: {}
}
</script>
<style lang="less" scoped>
.paper {
  display: flex;
  flex-wrap: wrap;
}
.test-paper {
  display: flex;
  flex-direction: column;
  height: 255px;
  background: url('../../assets/item.png') no-repeat;
  background-size: 100% 100%;
  transition: all .6s;
  .left-top {
    margin-left: 15px;
    margin-top: 15px;
    font-size: 14px;
    transition: all .6s;
  }
  .time {
    position: absolute;
    top: 45px;
    right: 50px;
    transition: all .6s;
    /deep/ .ivu-icon{
      margin-right: 5px;
    }
  }
  .top {
    height: 140px;
    border: 1px solid #ccc;
    border-radius: 6px;
    transition: all .6s;
  }
  .title {
    position: absolute;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    padding: 0 10px;
    overflow: hidden;
    transition: all .6s;
  }
  .count-info{
    position: absolute;
    top: 140px;
    left: 50%;
    display: inline-flex;
    justify-content: space-around;
    width: 200px;
    transform: translateX(-50%);
    transition: all .6s;
    .center,.as,.ct{
      position: absolute;
      top: 0;
    }
    .center{
      left: 50%;
      transform: translateX(-50%);
    }
    .ct{
      left: 50px;
    }
    .as{
      right: 0;
    }
    
  }
  /deep/ .ivu-btn {
    position: absolute;
    top: 180px;
    left: 50%;
    font-size: 14px;
    padding: 0 20px;
    outline: none;
    border-color: #ff9d00;
    transform: translateX(-50%);
    background-color: #fff;
    color: #ff9d00;
    transition: all .6s;
  }
}
.test-paper:hover {
  background: url('../../assets/itemActive.png') no-repeat;
  background-size: 100% 100%;
  .left-top,
  .time,
  .title,
  .count-info {
    color: #fff;
    /deep/ .ivu-icon {
      color: #fff !important;
    }
  }
  .title{
    border-bottom: 1px solid #fff;
  }
  /deep/ .ivu-btn {
    background-color: #fff;
    color: #ff9d00;
    border-color: #fff;
  }
}
/deep/ .ivu-spin{
    display: flex;
    width: 100%;
    height: 400px;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/practise/simulationTest.vue